import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import * as classNames from 'classnames';
import { InvoicesAppContext } from '../../context';
import { setSuffix } from '../../helpers';
import { checkPromotions } from '../../../../hooks/checkPromotions';

export const PackagePaymentView = ({
  name,
  promotions,
  expired,
  date,
  option,
  setOption,
  setDate,
  multiplyPackageData,
  todayDateOption,
  walletAmount,
  adsCount,
  expireDateOption,
  invoicePrice,
  handlePaymentClick,
  isPackagePaymentBlocked,
  discountedPrice,
  showPromotions,
  discount,
  showPaidDiscount,
  dateLoader
}) => {
  const { i18n, t } = useTranslation();
  const {
    isMobileSite
  } = useContext(InvoicesAppContext);
  const renderPromotions = checkPromotions(promotions, showPromotions);

  const packageDescription = classNames(
    'package-payment__item_description',
    name?.toLowerCase() === 'platinum+'
      ? 'platinum-plus' : name?.toLowerCase()
  );

  const packageInputs = (input, days) => classNames(
    { active: input === days }
  );

  const percentage = discountedPrice
    && ((Number(discountedPrice()) - invoicePrice) / (Number(discountedPrice()))) * 100;

  const showDiscount = discountedPrice() > invoicePrice;

  return (
    <>
      {!isMobileSite && (
        <>
          <p className="package-payment__title">{t('mobilePaymentPackTitle')}</p>
          <p className="package-payment__item_title">{t('payment.title')}</p>
        </>
      )}
      <div className="package-payment__items_container">
        <div className="package-payment__items">
          {isMobileSite && <p className="package-payment__title">{t('payment.title')}</p>}
          <div className="package-payment__item">
            <div className={packageDescription}>
              <p>{name}</p>
              <div className="package-info__container">
                <div className="package-info__left">
                  <div className="package-info">
                    {adsCount}
                    {t(setSuffix(i18n, adsCount, 'packages.count'))}
                  </div>
                  <div className="package-info">
                    {t('packages.services_price', { services_price: walletAmount })}
                  </div>
                </div>
                <div className="package-info__right">
                  {renderPromotions}
                  {showPaidDiscount && (
                    <div className="package-info">
                      {t('packages.discountServices', { discount })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="package-payment__item">
            <p className="package-payment__item_title">{t('packages.period')}</p>
            <div className="package-payment__inputs">
              <label
                htmlFor="value30"
                className={packageInputs(option, 30)}
              >
                <input
                  onClick={() => {
                    setOption(30);
                    multiplyPackageData();
                  }}
                  id="value30"
                  name="payment-option"
                  type="radio"
                  value="30"
                />
                <span>
                  {t('payment.period_days', { days: 30 })}
                </span>
                {
                  showDiscount && (
                    <div className="package-payment__item_discount">
                      %
                    </div>
                  )
                }
              </label>

              <label
                htmlFor="value60"
                className={packageInputs(option, 60)}
              >
                <input
                  onClick={() => {
                    setOption(60);
                    multiplyPackageData(2);
                  }}
                  id="value60"
                  name="payment-option"
                  type="radio"
                  value="60"
                  defaultChecked
                />
                <span>{t('payment.period_days', { days: 60 })}</span>
                {
                  showDiscount && (
                    <div className="package-payment__item_discount">
                      %
                    </div>
                  )
                }
              </label>

              <label
                htmlFor="value90"
                className={packageInputs(option, 90)}
              >
                <input
                  onClick={() => {
                    setOption(90);
                    multiplyPackageData(3);
                  }}
                  id="value90"
                  name="payment-option"
                  type="radio"
                  value="90"
                />
                <span>{t('payment.period_days', { days: 90 })}</span>
                {
                  showDiscount && (
                    <div className="package-payment__item_discount">
                      %
                    </div>
                  )
                }
              </label>
            </div>
          </div>
          <div className="package-payment__item">
            <p className="package-payment__item_title">{t('payment.activate')}</p>
            {dateLoader ? (
              <div className="invoices_preloader" style={{ margin: 'auto' }}>Loading ...</div>
            ) : (
              <div className="package-payment__inputs">
                <label
                  htmlFor="today"
                  className={packageInputs(date, todayDateOption)}
                >
                  <input
                    onClick={() => setDate(todayDateOption)}
                    id="today"
                    name="payment-day"
                    type="radio"
                    value={t('payment.today')}
                  />
                  <span>{t('payment.today')}</span>
                </label>

                { expired && (
                <label
                  htmlFor="date"
                  className={packageInputs(date, expireDateOption)}
                >
                  <input
                    onClick={() => setDate(expireDateOption)}
                    id="date"
                    name="payment-day"
                    type="radio"
                    value={expired}
                    defaultChecked
                  />
                  <span>
                    {expireDateOption }
                  </span>
                </label>
                )}
              </div>
            )}
          </div>
          {!isMobileSite && (
            <p className="package-payment__confirm-rules">
              <span>{t('modal.confirmRules1')}</span>
              <a href="/pages/terms-and-conditions">{t('modal.confirmRules2')}</a>
              <span>{t('modal.confirmRules4')}</span>
              <a href="/pages/proposal">{t('modal.confirmRules5')}</a>
              <span>{t('modal.confirmRules6')}</span>
            </p>
          )}
        </div>
        <div className="package-payment__info">
          <div className="package-payment__info_result">
            { isMobileSite && (
              <p>{t('payment.finish_title')}</p>
            ) }
            <div className="package-payment__info_result-content">
              <div className="package-payment__info_titles">
                <div>{t('payment.title')}</div>
                <div>{t('payment.period')}</div>
                <div>{t('payment.date_of_apply')}</div>
                <div>{t('payment.finish')}</div>
              </div>
              <div className="package-payment__info_values">
                <div>{name}</div>
                <div>{t('payment.period_days', { days: option })}</div>
                <div>{ date }</div>
                <div className="package-payment__info_price">
                  { discountedPrice && percentage > 0 && (
                  <div className="package-payment__info_discount">
                    <span>{`${discountedPrice()} AZN`}</span>
                    <span>{`-${percentage?.toFixed(0)}%`}</span>
                  </div>
                  )}
                  {`${invoicePrice} AZN`}
                </div>
              </div>
            </div>
          </div>

          <footer className="package-payment__info_footer">
            <button
              className="invoices_balance-pay"
              value={t('pay')}
              type="button"
              disabled={isPackagePaymentBlocked}
              onClick={handlePaymentClick}
            >
              {t('pay')}
            </button>
          </footer>
        </div>
      </div>
    </>
  );
};
